import { render, staticRenderFns } from "./IconBusiness.vue?vue&type=template&id=01680184&"
import script from "./IconBusiness.vue?vue&type=script&lang=js&"
export * from "./IconBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports